module.exports = __webpack_public_path__ + "img/stars-illustration.64c78ce4.svg";